module.exports = __webpack_public_path__ + "static/media/whitelogo.e8036f17.png";